import React from 'react'
import { Row, Col } from 'react-bootstrap'
import {
    Table,
} from 'react-bootstrap'
import defaultImg from '../../../../../../assets/images/no-img-found.png'
import 'react-day-picker/lib/style.css';

export default function ListingTable(props) {
    const { lines,
        //  sale_order_no, setSaleOrderNo, terms,setTerms,
        comments, setComment, staffNotes, setStaffNotes } = props

    let total = 0
    lines.forEach(line => {
        total = total + (line.quantity || 0) * (line.variant_price || (line.price || 0))
    });

    return (

        <React.Fragment>

            {/* <div className="topbar-table-form">
                <Row>
                    <Col>
                        <label>Sale Order No.</label>
                        <input
                            className="form-control"
                            placeholder="Sale Order No."
                            id="Sale Order No."
                            value={sale_order_no}
                            type="text"
                            onChange={(e) => { setSaleOrderNo(e.target.value) }}
                        />
                    </Col>
                    <Col>
                        <label>Sale Order Date</label>
                        <div className="addon-icon-right">
                            <DayPickerInput
                                inputProps={{
                                    className: 'form-control',
                                }}
                                classNames={{ container: 'date-picker-container' }}
                                dayPickerProps={{
                                    todayButton: 'Today',
                                    disabledDays: { before: moment().add(1, "days").toDate() }
                                }}
                                formatDate={formatDate}
                                format={FORMAT}
                                parseDate={parseDate}
                                placeholder={"YYYY-MM-DD"}
                                disabledDays={{ daysOfWeek: [0] }}
                            />
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                            </span>
                        </div>
                    </Col>

                    <Col>
                        <label>Due Date</label>
                        <div className="addon-icon-right">
                            <DayPickerInput
                                inputProps={{
                                    className: 'form-control',
                                }}
                                classNames={{ container: 'date-picker-container' }}
                                dayPickerProps={{
                                    todayButton: 'Today',
                                    disabledDays: { before: moment().add(1, "days").toDate() }
                                }}
                                formatDate={formatDate}
                                format={FORMAT}
                                parseDate={parseDate}
                                placeholder={"YYYY-MM-DD"}
                                disabledDays={{ daysOfWeek: [0] }}

                            />
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                            </span>
                        </div>
                    </Col>
                    <Col>
                        <label>Terms
                            <span>
                                <OverlayTrigger
                                    placement={"right"}
                                    overlay={renderTooltipHelp}
                                >
                                    <button
                                        className="st-round-btn st-btn-transparent st-btn-xs btn-help"
                                    >
                                        <FeatherIcon
                                            icon="help-circle"
                                            size="15"
                                            className="icon" />
                                    </button>
                                </OverlayTrigger>
                            </span>
                        </label>
                        <input
                            className="form-control"
                            placeholder="Terms"
                            id="terms"
                            value={terms}
                            type="text"
                            onChange={(e) => { setTerms(e.target.value) }}
                        />
                    </Col>
                </Row>
            </div> */}

            <div className="st-listing-table mt-2">
                <Table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Product/Service</th>
                            <th>Qty</th>
                            <th>Item Price</th>
                            <th>Item Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lines.filter(e => e.product_name).map((line, index) => {
                            return <tr key={index}>
                                <td className="w-50 ">
                                    <div className="d-flex align-items-center">
                                        <img src={defaultImg} alt="product" />
                                        <div>{line.product_name}<br />
                                            {line.variant_sku}
                                            <br />
                                            <span>{line.variant || line.variant_name}</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {line.quantity || 1}
                                </td>
                                <td>${line.variant_price || line.price}.00</td>
                                <td>
                                    ${((line.quantity || 0) * (line.variant_price || (line.price || 0))) || (line.variant_price || line.price)}.00
                                </td>
                            </tr>
                        })}

                        {/* <tr>
                            <td>
                                <img src={defaultImg} alt="product" />
                                [Sample] Fog Linen Chambray Towel - Beige Stripe...
                            </td>
                            <td>0</td>
                            <td>0.00</td>
                            <td>0.00</td>
                        </tr>
                        */}
                    </tbody>
                </Table>
            </div>

            <div className="comment-and-note">
                <h5>Comments and Notes</h5>
                <Row>
                    <Col>
                        <div className="d-flex align-items-top justify-content-between">
                            <label>Comments</label>
                            <textarea
                                className="form-control"
                                placeholder="Visible to customer"
                                id="comments"
                                value={comments}
                                cols="30"
                                rows="3"
                                type="text"
                                onChange={(e) => { setComment(e.target.value) }}
                            />
                        </div>
                    </Col>
                    <Col>
                        <div className="d-flex align-items-top justify-content-between">
                            <label>Staff Notes</label>
                            <textarea
                                className="form-control"
                                placeholder="Visible to customer"
                                id="comments"
                                value={staffNotes}
                                cols="30"
                                rows="3"
                                type="text"
                                onChange={(e) => { setStaffNotes(e.target.value) }}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}
